import { render, staticRenderFns } from "./Q2.vue?vue&type=template&id=2806df31&scoped=true&"
import script from "./Q2.vue?vue&type=script&lang=js&"
export * from "./Q2.vue?vue&type=script&lang=js&"
import style0 from "./Q2.vue?vue&type=style&index=0&id=2806df31&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2806df31",
  null
  
)

export default component.exports